import React from 'react'
import Typewriter from 'typewriter-effect'
import { Box, Text } from '@chakra-ui/react'
import { Link } from '@chakra-ui/react'
import { Button} from '@chakra-ui/react'

// border="1px solid red"

const Header = () => {
  return (
      <Box 
        id='home'  
        align={"center"}
        pt="130px"
        w="80%"
        >
      
        <Box 
          m={["10px","30px","30px"]}
          fontWeight="bold" 
          fontSize={[null,"20px","30px"]} 
          >
          <Box id="user-detail-name" fontSize={["25px","40px","60px"]}  display="flex" w={["300px", "500px", "700px"]}>
            <Text color="orange.900" >Hello, I'm &nbsp;</Text>
            <Text  color="blue.900">Tarun Sharma</Text>
          </Box>
          

          <Box mt="20px" >
          <Typewriter
                options={{
                  strings: [
                      "A MERN Stack Developer.",
                      "A Problem Solver.",
                  ],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 80,
                }}
              />
          </Box>
              
        </Box>
        
        
       

        <Box  > 
              <Link 
                  id="resume-button-2"
                  style={{ textDecoration: 'none' }}  
                  href="https://drive.google.com/uc?export=download&id=1jf0aDcplQQDA0_FoYrKm9QOg_8_zK91a"
                   >
                    <Button m="50px" 
                      bgGradient='linear(to-r, orange.900, blue.900)'
                      onClick={()=>{
                        window.open("https://drive.google.com/file/d/1jf0aDcplQQDA0_FoYrKm9QOg_8_zK91a/view?usp=sharing","_blank")
                      }}
                      _hover={{
                      bgGradient: 'linear(to-r, cyan.500, blue.500)',
                      boxShadow:'dark-lg',
                      transitionDuration:"300ms",
                      }}    
                      color="white">
                      ⤓ Download Resume
                    </Button>
              </Link>
              <Link
                  style={{ textDecoration: 'none' }}  
                  href="#contact" >
                    <Button m="10px"
                    _hover={{
                      boxShadow:'dark-lg',
                      transitionDuration:"300ms",
                      }} 
                    variant="outline" 
                    colorScheme='facebook'>
                    Let's Talk
                    </Button>
              </Link>
        </Box>



        <Box m={["5px","10px","20px"]}  fontSize={[null,"15px","20px"]} >
          <Text textAlign="justify" >
            


            Hello Everyone, I am Tarun Sharma from Chandigarh.
                          I am a highly inquisitive person with a passion for solving problems and implementing solutions in real life.
                           I am constantly seeking new challenges and opportunities to put my 
                           problem-solving skills to the test. My interest in puzzles, self-help
                            books, and astrophysics stems from my love of understanding the mechanics
                             and working principles of the things around me. I find excitement in
                              delving deep into a subject and uncovering the complexities that make
                               it function. My innate curiosity and drive to learn have led me to 
                               continually seek out new experiences and knowledge, and I am eager
                                to see where they take me next.
          </Text>
        </Box> 

      </Box>
        

  )
}

export default Header
